<template>
  <v-container class="my-5" fluid>
    <v-card class="mx-auto my-4 modern-card" max-width="1200">
      <v-row no-gutters>
        <!-- Contact Info Section (Left on large screens) -->
        <v-col cols="12" md="4" class="pa-4">
          <v-card-title class="text-h3" style="color: #002250;">Contact Us</v-card-title>
          <v-card-text class="text-h6" style="color: #002250;">
            <v-list v-if="!loading && contactData">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title><strong>Address:</strong></v-list-item-title>
                  <v-list-item-subtitle>{{ contactData.address }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-phone</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title><strong>Phone:</strong></v-list-item-title>
                  <v-list-item-subtitle>{{ contactData.phone_1 }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-title><strong>Phone:</strong></v-list-item-title>
                  <v-list-item-subtitle>{{ contactData.phone_2 }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-email</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title><strong>Email:</strong></v-list-item-title>
                  <v-list-item-subtitle>{{ contactData.email }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-row v-if="loading">
              <v-col class="text-center">
                <v-progress-circular indeterminate></v-progress-circular>
              </v-col>
            </v-row>
            <p v-else-if="!loading && !contactData">Contact information not available.</p>

            <!-- Google Maps Section -->
            <v-card class="mt-4">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d304.13877572305415!2d110.82299058715353!3d-7.600034483193256!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sid!4v1786715021598!5m2!1sen!2sid"
                width="100%"
                height="300"
                style="border:0;"
                allowfullscreen
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                title="Lokasi GP21SHOP"
              ></iframe>
            </v-card>
          </v-card-text>
        </v-col>

        <!-- Contact Form Section (Right on large screens) -->
        <v-col cols="12" md="8" class="pa-4">
          <v-card-title class="text-h3" style="color: #002250;">Get in Touch</v-card-title>
          <v-form ref="form">
            <v-text-field label="Name" v-model="form.name" required></v-text-field>
            <v-text-field label="Subject" v-model="form.subject" required></v-text-field>
            <v-text-field label="Email" v-model="form.email" required></v-text-field>
            <v-text-field label="Phone" v-model="form.phone_number" required></v-text-field>
            <v-textarea label="Message" v-model="form.message" required></v-textarea>
            <v-btn
              :loading="submitting"
              rounded="xl"
              variant="elevated"
              block
              @click="submitForm"
              color="#002250"
            >
              Send
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-card>

    <!-- Snackbar for Success/Error messages -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000">
      {{ snackbar.message }}
    </v-snackbar>
  </v-container>
</template>


<script>
export default {
  name: "Contact",
  data() {
    return {
      contactData: null, // To hold the fetched contact information
      form: {
        name: '',
        subject: '',
        email: '',
        phone_number: '', // Add phone to the form data model
        message: ''
      },
      loading: false, // To handle the loading state
      submitting: false, // To handle form submission state
      snackbar: {
        show: false,
        message: '',
        color: ''
      }
    };
  },
  async created() {
    await this.fetchContactData();
  },
  methods: {
    async fetchContactData() {
  this.loading = true;
  try {
    const response = await this.$axios.get('/contact'); // Ensure the endpoint is correct
    if (response.data && response.data.data) {
      this.contactData = response.data.data; // Correctly assigning the object
    }
  } catch (error) {
    console.error('Error fetching contact information:', error);
  } finally {
    this.loading = false;
  }
},
    async submitForm() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        try {
          const response = await this.$axios.post('/messages', this.form); // API to submit the form
          console.log('Message submitted:', response.data);

          // Show success message in snackbar
          this.snackbar = {
            show: true,
            message: 'Message sent successfully',
            color: 'success'
          };

          // Reset form after successful submission
          this.form.name = '';
          this.form.subject = '';
          this.form.email = '';
          this.form.phone_number = ''; // Reset the phone field
          this.form.message = '';
        } catch (error) {
          console.error('Error submitting message:', error);

          // Show error message in snackbar
          this.snackbar = {
            show: true,
            message: 'Failed to send message',
            color: 'error'
          };
        } finally {
          this.submitting = false;
        }
      }
    }
  }
};
</script>

<style scoped>
/* Add any custom styles here */
</style>
